var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from "@mui/icons-material/Close";
import { Alert, Dialog, DialogActions, Grid } from "@mui/material";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Typography from "@mui/material/Typography";
import * as React from "react";
import { imprimiTermoAnistiaOuAvisoPagarDare, gerarDARPDF, } from "../../apis/api";
import PrintIcon from "@mui/icons-material/Print";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../Loading";
import { useHistory } from "react-router-dom";
var BootstrapDialog = styled(Dialog)(function (_a) {
    var theme = _a.theme;
    return ({
        "& .MuiDialogContent-root": {
            padding: theme.spacing(2),
        },
        "& .MuiDialogActions-root": {
            padding: theme.spacing(1),
        },
        "& .MuiDialog-paper": {
            marginLeft: 10,
            marginRight: 10,
        },
    });
});
var borda = {
    border: "1px solid #45444477",
    borderRadius: "6px",
    width: "100%",
    marginBottom: "1rem",
};
function createData(id, vencimento, conta, numeroDocumento, valorDivida, valorImposto, multa, juros) {
    return {
        id: id,
        vencimento: vencimento,
        conta: conta,
        numeroDocumento: numeroDocumento,
        valorDivida: valorDivida,
        valorImposto: valorImposto,
        multa: multa,
        juros: juros,
    };
}
export function DialogDocumentosGerados(_a) {
    var _b, _c, _d, _e;
    var open = _a.open, onClose = _a.onClose, data = _a.data, anistiaGerada = _a.anistiaGerada;
    var _f = React.useState(false), loading = _f[0], setLoading = _f[1];
    var infoAnistia = (_e = (_d = (_c = (_b = anistiaGerada === null || anistiaGerada === void 0 ? void 0 : anistiaGerada.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.conteudoSaida) === null || _e === void 0 ? void 0 : _e.conteudoSaida;
    var history = useHistory();
    function formataParaDinheiroBr(valor) {
        return valor.toLocaleString("pt-BR", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        });
    }
    function onCloseModal() {
        toast.success("Anistia gerada com sucesso!");
        history.push("/dar-ipva/debitos");
    }
    function gerarDar() {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var parcelaComum, parcelaData, response, arquivo, byteCharacters, byteNumbers, i, byteArray, blob, url, link, error_1;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        parcelaComum = (_a = infoAnistia === null || infoAnistia === void 0 ? void 0 : infoAnistia.listaParcelas) === null || _a === void 0 ? void 0 : _a.find(function (parcela) { return parcela.codigoReceita !== 310129; });
                        if (!parcelaComum) {
                            toast.warning("Nenhuma parcela encontrada para pagamento");
                            return [2 /*return*/];
                        }
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, 4, 5]);
                        setLoading(true);
                        parcelaData = {
                            numeroAnistia: parcelaComum.numeroAnistia,
                            numeroParcela: parcelaComum.numeroParcela,
                            periodo: String(parcelaComum.periodo),
                            codigoReceita: parcelaComum.codigoReceita,
                            dataVencimento: parcelaComum.dataVencimento,
                            valorImposto: parcelaComum.valorImposto,
                            valorMulta: parcelaComum.valorMulta,
                            valorJuros: parcelaComum.valorJuros,
                            valorParcela: parcelaComum.valorParcela,
                        };
                        return [4 /*yield*/, gerarDARPDF(parcelaData)];
                    case 2:
                        response = _d.sent();
                        arquivo = (_c = (_b = response.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.arquivo;
                        if (arquivo) {
                            if (arquivo === "base64-encoded-pdf-here" || arquivo.length < 100) {
                                toast.error("Serviço temporariamente indisponível. Tente novamente mais tarde.");
                                return [2 /*return*/];
                            }
                            try {
                                byteCharacters = atob(arquivo);
                                byteNumbers = new Array(byteCharacters.length);
                                for (i = 0; i < byteCharacters.length; i++) {
                                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                                }
                                byteArray = new Uint8Array(byteNumbers);
                                blob = new Blob([byteArray], { type: "application/pdf" });
                                url = window.URL.createObjectURL(blob);
                                link = document.createElement("a");
                                link.href = url;
                                link.download = "dar_anistia_".concat(parcelaData.numeroAnistia, "_parcela_").concat(parcelaData.numeroParcela, ".pdf");
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                window.URL.revokeObjectURL(url);
                                toast.success("DAR gerado com sucesso!");
                            }
                            catch (error) {
                                toast.error("Erro ao processar o arquivo PDF");
                            }
                        }
                        else {
                            toast.error("Arquivo não disponível. Tente novamente.");
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _d.sent();
                        toast.error("Erro ao gerar DAR");
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function pagarHonorario() {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function () {
            var parcelaHonoraria, parcelaData, response, arquivo, byteCharacters, byteNumbers, i, byteArray, blob, url, link, error_2;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        parcelaHonoraria = (_a = infoAnistia === null || infoAnistia === void 0 ? void 0 : infoAnistia.listaParcelas) === null || _a === void 0 ? void 0 : _a.find(function (parcela) { return parcela.codigoReceita === 310129; });
                        if (!parcelaHonoraria) {
                            toast.warning("Parcela de honorário não encontrada");
                            return [2 /*return*/];
                        }
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 3, 4, 5]);
                        setLoading(true);
                        parcelaData = {
                            numeroAnistia: parcelaHonoraria.numeroAnistia,
                            numeroParcela: parcelaHonoraria.numeroParcela,
                            periodo: String(parcelaHonoraria.periodo),
                            codigoReceita: parcelaHonoraria.codigoReceita,
                            dataVencimento: parcelaHonoraria.dataVencimento,
                            valorImposto: parcelaHonoraria.valorImposto,
                            valorMulta: parcelaHonoraria.valorMulta,
                            valorJuros: parcelaHonoraria.valorJuros,
                            valorParcela: parcelaHonoraria.valorParcela,
                        };
                        return [4 /*yield*/, gerarDARPDF(parcelaData)];
                    case 2:
                        response = _d.sent();
                        arquivo = (_c = (_b = response.data) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.arquivo;
                        if (arquivo) {
                            if (arquivo === "base64-encoded-pdf-here" || arquivo.length < 100) {
                                toast.error("Serviço temporariamente indisponível. Tente novamente mais tarde.");
                                return [2 /*return*/];
                            }
                            try {
                                byteCharacters = atob(arquivo);
                                byteNumbers = new Array(byteCharacters.length);
                                for (i = 0; i < byteCharacters.length; i++) {
                                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                                }
                                byteArray = new Uint8Array(byteNumbers);
                                blob = new Blob([byteArray], { type: "application/pdf" });
                                url = window.URL.createObjectURL(blob);
                                link = document.createElement("a");
                                link.href = url;
                                link.download = "dar_honorario_".concat(parcelaData.numeroAnistia, "_parcela_").concat(parcelaData.numeroParcela, ".pdf");
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                window.URL.revokeObjectURL(url);
                                toast.success("Documento de honorário gerado com sucesso!");
                            }
                            catch (error) {
                                toast.error("Erro ao processar o arquivo PDF");
                            }
                        }
                        else {
                            toast.error("Arquivo não disponível. Tente novamente.");
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_2 = _d.sent();
                        toast.error("Erro ao gerar documento de honorário");
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    var rows = [
        createData(1, "14/11/2023", "NOTIFICAÇÃO", 2508338001590, "teste", "teste", "teste", "teste"),
    ];
    if (infoAnistia) {
        rows = infoAnistia.listaRetorno.map(function (item) {
            return createData(Number(item.numeroAnistia), item.limitepago, item.numCtaImp, item.numDocumento, formataParaDinheiroBr(item.valorDividaAnterior), formataParaDinheiroBr(item.imposto), formataParaDinheiroBr(item.valorMultaAnterior), formataParaDinheiroBr(item.valorJurosAnterior));
        });
    }
    function handleTermoOuAvisoDeDebito(tipo) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function () {
            var numeroAnistia, response, arquivo, byteCharacters, byteNumbers, i, byteArray, blob, url, link, error_3;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        if (!(infoAnistia === null || infoAnistia === void 0 ? void 0 : infoAnistia.numAnistia)) {
                            toast.error("Número da anistia não encontrado");
                            return [2 /*return*/];
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, 4, 5]);
                        setLoading(true);
                        numeroAnistia = Number(infoAnistia.numAnistia);
                        return [4 /*yield*/, imprimiTermoAnistiaOuAvisoPagarDare(numeroAnistia, tipo)];
                    case 2:
                        response = _c.sent();
                        arquivo = (_b = (_a = response.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.arquivo;
                        if (arquivo) {
                            if (arquivo === "base64-encoded-pdf-here" || arquivo.length < 100) {
                                toast.info("Ambiente de desenvolvimento: API retornou placeholder ao invés de PDF real");
                                return [2 /*return*/];
                            }
                            try {
                                byteCharacters = atob(arquivo);
                                byteNumbers = new Array(byteCharacters.length);
                                for (i = 0; i < byteCharacters.length; i++) {
                                    byteNumbers[i] = byteCharacters.charCodeAt(i);
                                }
                                byteArray = new Uint8Array(byteNumbers);
                                blob = new Blob([byteArray], { type: "application/pdf" });
                                url = window.URL.createObjectURL(blob);
                                link = document.createElement("a");
                                link.href = url;
                                link.download =
                                    tipo === 1
                                        ? "termo_anistia_".concat(numeroAnistia, ".pdf")
                                        : "aviso_debito_".concat(numeroAnistia, ".pdf");
                                document.body.appendChild(link);
                                link.click();
                                document.body.removeChild(link);
                                window.URL.revokeObjectURL(url);
                                toast.success(tipo === 1
                                    ? "Termo de Anistia gerado com sucesso!"
                                    : "Aviso de Débito gerado com sucesso!");
                            }
                            catch (error) {
                                toast.error("Erro ao processar o arquivo PDF");
                            }
                        }
                        else {
                            toast.warning("Documento gerado, mas arquivo não disponível para download");
                        }
                        return [3 /*break*/, 5];
                    case 3:
                        error_3 = _c.sent();
                        toast.error("Erro ao gerar documento");
                        return [3 /*break*/, 5];
                    case 4:
                        setLoading(false);
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    return (_jsxs(BootstrapDialog, __assign({ onClose: function () { return onCloseModal(); }, "aria-labelledby": "customized-dialog-title", open: open, maxWidth: "xl", sx: { marginLeft: 0, marginRight: 0 } }, { children: [_jsx(Loader, { open: loading, sx: { color: "#fff" }, zIndex: 999 }), _jsx(ToastContainer, {}), _jsx(DialogTitle, __assign({ sx: { m: 0, p: 2, background: "#034ea2", color: "white" }, id: "customized-dialog-title", fontWeight: "bold" }, { children: "ANISTIA" })), _jsx(IconButton, __assign({ "aria-label": "close", onClick: function () { return onCloseModal(); }, sx: {
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: function (theme) { return theme.palette.grey[500]; },
                } }, { children: _jsx(CloseIcon, {}) })), _jsxs(DialogContent, __assign({ dividers: true }, { children: [_jsx(Alert, __assign({ style: { marginBottom: 10 }, severity: "success" }, { children: "Anistia Gerada com sucesso!" })), _jsx("div", __assign({ style: borda }, { children: _jsxs(Grid, __assign({ container: true }, { children: [_jsxs(Grid, __assign({ item: true, xs: 12, sm: 5, ml: 2 }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", variant: "subtitle1", display: "inline" }, { children: "Renavam:" })), _jsx(Typography, __assign({ ml: 2, variant: "body1", display: "inline" }, { children: data === null || data === void 0 ? void 0 : data.proprietario.renavan })), _jsx("br", {}), _jsx(Typography
                                        // ml={2}
                                        , __assign({ 
                                            // ml={2}
                                            fontWeight: "bold", variant: "subtitle1", display: "inline" }, { children: "Placa:" })), _jsx(Typography, __assign({ ml: 2, variant: "body1", display: "inline" }, { children: data === null || data === void 0 ? void 0 : data.proprietario.placa })), _jsx("br", {}), _jsx(Typography, __assign({ fontWeight: "bold", variant: "subtitle1", display: "inline" }, { children: "Ano de fabrica\u00E7\u00E3o:" })), _jsx(Typography, __assign({ ml: 2, variant: "body1", display: "inline" }, { children: data === null || data === void 0 ? void 0 : data.proprietario.anoFabricacao })), _jsx("br", {}), _jsx(Typography, __assign({ fontWeight: "bold", variant: "subtitle1", display: "inline" }, { children: "Nome/Raz\u00E3o Social:" })), _jsx(Typography, __assign({ ml: 2, variant: "body1", display: "inline" }, { children: data === null || data === void 0 ? void 0 : data.proprietario.nome }))] })), _jsxs(Grid, __assign({ item: true, xs: 12, sm: 5, ml: 2 }, { children: [_jsx(Typography, __assign({ fontWeight: "bold", variant: "subtitle1", display: "inline" }, { children: "Marca/Modelo:" })), _jsx(Typography, __assign({ ml: 2, variant: "body1", display: "inline" }, { children: data === null || data === void 0 ? void 0 : data.proprietario.marcaModelo })), _jsx("br", {}), _jsx(Typography, __assign({ fontWeight: "bold", variant: "subtitle1", display: "inline" }, { children: "Chassi:" })), _jsx(Typography, __assign({ ml: 2, variant: "body1", display: "inline" }, { children: data === null || data === void 0 ? void 0 : data.proprietario.chassi })), _jsx("br", {}), _jsx(Typography, __assign({ fontWeight: "bold", variant: "subtitle1", display: "inline" }, { children: "CPF/CNPJ:" })), _jsx(Typography, __assign({ ml: 2, variant: "body1", display: "inline" }, { children: data === null || data === void 0 ? void 0 : data.proprietario.cpfCnpjRenavan }))] }))] })) })), _jsxs("div", __assign({ style: borda }, { children: [_jsx(Typography, __assign({ color: "white", bgcolor: "#034ea2", align: "center", pt: 1, pb: 1, mb: 1, variant: "subtitle1" // Definir o estilo e o tamanho da fonte
                                , fontWeight: "bold" // Definir o texto em negrito
                             }, { children: "Documentos Gerados" })), _jsx(TableContainer, __assign({ component: Paper, sx: { borderRadius: 0 } }, { children: _jsxs(Table, __assign({ sx: { minWidth: 650 }, "aria-label": "simple table" }, { children: [_jsx(TableHead, __assign({ sx: { background: "#034ea2" } }, { children: _jsxs(TableRow, { children: [_jsx(TableCell, __assign({ align: "center", sx: { color: "white" } }, { children: "Vencimento" })), _jsx(TableCell, __assign({ align: "center", sx: { color: "white" } }, { children: "Conta" })), _jsx(TableCell, __assign({ align: "center", sx: { color: "white" } }, { children: "N\u00B0 Documento" })), _jsx(TableCell, __assign({ align: "center", sx: { color: "white" } }, { children: "Valor D\u00EDvida" })), _jsx(TableCell, __assign({ align: "center", sx: { color: "white" } }, { children: "Valor Imposto" })), _jsx(TableCell, __assign({ align: "center", sx: { color: "white" } }, { children: "Multa" })), _jsx(TableCell, __assign({ align: "center", sx: { color: "white" } }, { children: "Juros" })), _jsx(TableCell, __assign({ align: "center", sx: { color: "white" } }, { children: "Imprimir" }))] }) })), _jsx(TableBody, { children: rows.map(function (row) { return (_jsxs(TableRow, __assign({ sx: { "&:last-child td, &:last-child th": { border: 0 } } }, { children: [_jsx(TableCell, __assign({ align: "center", component: "th", scope: "row" }, { children: row.vencimento })), _jsx(TableCell, __assign({ align: "center" }, { children: row.conta })), _jsx(TableCell, __assign({ align: "center" }, { children: row.numeroDocumento })), _jsxs(TableCell, __assign({ align: "center" }, { children: ["R$ ", row.valorDivida] })), _jsxs(TableCell, __assign({ align: "center" }, { children: ["R$ ", row.valorImposto] })), _jsxs(TableCell, __assign({ align: "center" }, { children: ["R$ ", row.multa] })), _jsxs(TableCell, __assign({ align: "center" }, { children: ["R$ ", row.juros] })), row.conta === "NOTIFICAÇÃO" && (_jsx(TableCell, __assign({ align: "center" }, { children: _jsx(PrintIcon, { style: { cursor: "pointer" }, onClick: function () { return handleTermoOuAvisoDeDebito(2); } }) })))] }), row.id)); }) })] })) }))] }))] })), _jsxs(DialogActions, __assign({ sx: { justifyContent: "center" } }, { children: [_jsx(Button, __assign({ variant: "contained", autoFocus: true, onClick: function () { return handleTermoOuAvisoDeDebito(1); } }, { children: "Termo de Anistia" })), _jsx(Button, __assign({ variant: "contained", onClick: gerarDar }, { children: "Pagar DAR (1\u00B0 parcela)" })), (infoAnistia === null || infoAnistia === void 0 ? void 0 : infoAnistia.listaParcelas) &&
                        infoAnistia.listaParcelas.some(function (parcela) { return parcela.codigoReceita === 310129; }) && (_jsx(Button, __assign({ variant: "contained", onClick: pagarHonorario }, { children: "Pagar honorario" })))] }))] })));
}
